import gsap from "gsap"
import { Power2 } from "gsap"
const animationLoad = () =>{
    document.addEventListener("DOMContentLoaded", function () {

        let tlLoad = gsap.timeline()

        tlLoad
            .to('.logo, .menu__nav > .menu-item > a',{
                opacity :1,
                y : "0%",
                duration : 0.5,
                stagger : 0.1,
                ease : Power2.easeOut
            })
            .to('.fade-up-slow, .fade-up',{
            opacity :1,
            y : "0%",
            duration : 0.8,
            stagger : 0.2,
            ease : Power2.easeOut
        }, "-=1")
    })
}

export default animationLoad